const APP_ROUTE_SEGMENTS = new Set([
  'appartamenti',
  'scheda-appartamento',
  'scheda-pertinenza',
  'crea-appartamenti',
  'clienti',
  'clienti-legacy',
  'scheda-cliente',
  'modifica-cliente',
  'aggiungi-cliente',
  'userInfoManager',
  'calendario',
  'dettagli-calendario',
  'new-event',
  'update-event',
  'update-busy-slot',
  'accountManager',
  'preventivi',
  'gestioneProposta',
  'documenti-hc',
  'resetPassword',
  'login',
]);

export const utilityGetBaseName = () => {
  const { origin, pathname } = window.location;
  const segments = pathname.split('/').filter(Boolean);
  const routeIndex = segments.findIndex((segment) => APP_ROUTE_SEGMENTS.has(segment));

  if (routeIndex >= 0) {
    const baseSegments = segments.slice(0, routeIndex);
    const basePath = `/${baseSegments.join('/')}`;
    return origin + (basePath === '/' ? '/' : `${basePath}/`);
  }

  // Fallback for non-app routes: preserve trailing slash semantics.
  const fallbackBasePath = pathname.endsWith('/') ? pathname : `${pathname.slice(0, pathname.lastIndexOf('/') + 1)}`;
  return origin + (fallbackBasePath || '/');
};
